<template>
  <div class="mb-2 habilitacao">
    <div class="row">
      <div class="col">
        <sub-header-grey class="pt-2 pl-3 mb-3">
          <label class="label">Registrador</label>
        </sub-header-grey>

        <div class="col">
          <div class="row">
            <div class="col-5">
              <div class="form-group">
                <label class="label">
                  Nome do digitador
                </label>
                <select ref="nome_digitador"
                        v-model="registro.digitador"
                        class="form-control form-control-sm"
                        required
                        @blur="validateInput"
                        @change="emitChange(), validateInput($event)">
                  <option :value="null">
                    Selecione o digitador:
                  </option>
                  <option v-for="(digitador, index) of options.digitadores"
                          :key="`habilitacao_registro_${ index }`"
                          :value="digitador.nome">
                    {{ digitador.nome }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-5">
              <div class="form-group">
                <label class="label">
                  Escrevente
                </label>
                <select id="selectEscrevente"
                        v-model="registro.escrevente"
                        class="form-control form-control-sm"
                        required
                        @blur="validateInput"
                        @change="changeEscrevente(), validateInput($event)">
                  <option :value="null">
                    Selecione o escrevente:
                  </option>
                  <option v-for="(escrevente, index) of options.escreventes"
                          :key="`habilitacao_registro_${ index }`"
                          :value="escrevente.nome">
                    {{ escrevente.nome }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!registro.registro_id"
         class="form-group">
      <div class="row">
        <div class="col">
          <sub-header-grey class="pt-2 pl-4 mb-3">
            <label class="label">Edital</label>
          </sub-header-grey>
          <div class="col pl-4 mb-3">
            <div class="row">
              <span class="custom-control custom-switch mr-4">
                <input id="impressaoEdital"
                       ref="impressaoEdital"
                       v-model="impressao_edital"
                       class="custom-control-input"
                       name="impressaoEdital"
                       type="checkbox"
                       value="O"
                       @change="changeImpressaoEdital()"
                       @keydown.enter="changeFlagImpressao()">
                <label class="custom-control-label"
                       for="impressaoEdital">Imprimir Edital do Proclamas e Declarações para Casamento</label>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="registro.registro_id">
      <div class="row">
        <div class="col">
          <sub-header-grey class="pt-2 pl-3 mb-3 ">
            <label class="label">Registro</label>
          </sub-header-grey>
        </div>
      </div>

      <div class="row px-2 mb-4">
        <div class="col-2">
          <label
            class="label"
            for="falecido_digitador_nome">Livro</label>
          <input v-if="registro.livro"
                 v-model="registro.livro.num_livro"
                 v-validate="'required'"
                 type="number"
                 :disabled="!!propHabilitacao.gerar_autuacao"
                 name="registro_livro"
                 :class="{'is-invalid' : errors.has('registro_livro')}"
                 class="form-control form-control-sm"
                 @change="emitChange()">
        </div>

        <div class="col-2">
          <label
            class="label"
            for="falecido_digitador_nome">Folha</label>
          <input v-model="registro.folha"
                 v-validate="'required'"
                 type="number"
                 :disabled="!!propHabilitacao.gerar_autuacao"
                 name="registro_folha"
                 :class="{'is-invalid' : errors.has('registro_folha')}"
                 class="form-control form-control-sm"
                 @change="emitChange()">
        </div>

        <div class="col-2">
          <label
            class="label"
            for="falecido_digitador_nome">Termo</label>
          <input v-model="registro.termo"
                 v-validate="'required'"
                 type="number"
                 :disabled="!!propHabilitacao.gerar_autuacao"
                 name="registro_termo"
                 :class="{'is-invalid' : errors.has('registro_termo')}"
                 class="form-control form-control-sm"
                 @change="emitChange()">
        </div>

        <div class="col-2">
          <label
            class="label"
            for="falecido_digitador_nome">Lado</label>
          <select v-model="registro.lado"
                  v-validate="'required'"
                  name="registro_lado"
                  :disabled="!!propHabilitacao.gerar_autuacao"
                  :class="{'is-invalid' : errors.has('registro_lado')}"
                  class="form-control form-control-sm"
                  @change="emitChange()">
            <option>FRENTE</option>
            <option>VERSO</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* components */
  import SubHeaderGrey from "@/components/SofiaRei/Headers/SubHeaderGrey"

  /* services */
  import UsuarioService from "@/services/Auth/UsuarioService"

  /* others */
  import { mapGetters } from 'vuex'

  export default {
    name: "Habilitacao",
    components: {
      SubHeaderGrey
    },
    props: {
      propHabilitacao: { type: Object, default: () => Object.create(null) },
      propRegistro: { type: Object, default: () => Object.create(null) },
      propPublicacao: { type: String, default: null },
      propTipoCasamento: { type: String, default: null},
      propTab: { type: Number, default: () => 0}
    },
    data () {
      return {
        options: {
          digitadores: null,
          escreventes: null
        },
        registro: {
          digitador: null,
          escrevente: null,
          termo: null,
          livro: {
            num_livro: null
          },
          folha: null,
          lado: null,
          oficial: null,
          cargo_escrevente: null
        },
        impressao_edital: true,
        sequenciaRegistro: null
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser',
        cartorioObj: 'auth/getCartorioObj',
      }),
    },
    watch: {
      propRegistro () {
        this.init()
      },
      propTab () {
        if ((this.propTab == 5 && this.propTipoCasamento !== 'Afixação de edital de outra serventia') || (this.propTab == 4 && this.propTipoCasamento === 'Afixação de edital de outra serventia')) {
          this.$refs.nome_digitador.focus()
        }
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      async init () {
        if (!this.sequenciaRegistro && this.propRegistro.registro_id) {
          // pegando sequencia de dado do registro para identificar mudanca
          let { livro: { num_livro }, folha, termo } = this.propRegistro
          this.sequenciaRegistro = [num_livro, folha, termo].join('')
        }

        Object.assign(this.registro, { ...this.propRegistro })

        const usuarios = await UsuarioService.getUsuarios().then(res => res.data)
        this.options.escreventes = [ ...usuarios.filter(user => user.escrevente == 1) ]
        this.options.digitadores = [ ...usuarios ]

        if (!this.registro.escrevente && !!this.user.escrevente) {
          this.registro.escrevente = this.user.nome
          this.registro.cargo_escrevente = this.user.cargo
        }

        if (!this.registro.digitador) this.registro.digitador = this.user.nome

        if (!this.registro.oficial) {
          this.registro.oficial = this.cartorioObj.nome_oficial
        }

        this.validateAll()
        this.checkActive()
        this.emitChange()
      },
      checkActive () {
        const { digitador, escrevente } = this.registro

        /**
         * Quando o tipo de casamento for afixação de edital não existe o passo
         * impressão de peças, por isso diminuimos o número do passo atual
         */
        let passo = 5

        if (this.propTipoCasamento === 'Afixação de edital de outra serventia') {
          passo = 4
        }

        if (digitador && escrevente) {
          this.$emit('onActive', true, passo)
        } else {
          this.$emit('onActive', false, passo)
        }
      },
      emitChange () {
        let { livro: { num_livro }, folha, termo } = this.registro
        const sequenciaLocal = [num_livro, folha, termo].join('')

        if (this.sequenciaRegistro != sequenciaLocal) {
          this.registro.origem = 'legado'
        } else {
          this.registro.origem = 'novo'
        }

        this.registro.impressao_edital = this.impressao_edital

        this.$emit('onEmitChange', this.registro)

        this.checkActive()
      },

      validateInput (event) {
        if (event.target.value != '') {
          event.target.classList.remove("is-invalid")
        } else {
          event.target.classList.add("is-invalid")
        }

        // this.activeChange();
      },

      validateAll () {
        setTimeout(() => {
          const fields = document.querySelectorAll(".habilitacao [required]")

          const invalids = Object.keys(fields).filter(field => fields[field].value != '')

          if (invalids.length == 0) {
            return
          }

          Object.keys(fields).map(field => {
            if (fields[field].value != '') {
              fields[field].classList.remove("is-invalid")
            } else {
              fields[field].classList.add("is-invalid")
            }
          })
          this.$emit('onActive', false, 2)
        }, 100)
      },
      changeImpressaoEdital () {
        this.impressao_edital = !!this.impressao_edital
        this.emitChange()
      },
      changeEscrevente () {
        if (this.registro.escrevente) {
          const selectEscreventes = document.getElementById('selectEscrevente')
          this.registro.cargo_escrevente  = this.options.escreventes[selectEscreventes.selectedIndex - 1].cargo
        }
        this.emitChange()

      },
      changeFlagImpressao () {
        this.impressao_edital = !this.impressao_edital
        this.changeImpressaoEdital()
      }
    }
  }
</script>

<style scoped>

</style>
